import React, {useState} from "react";
import PropTypes from "prop-types";


export default function About(prop) {
    //enabling dark mode with button in previous mode
    // const [myStyle, setMyStyle] = useState({
    //     color: 'black',
    //     backgroundColor: 'white'
    // })
    // const [btnText, setBtnText] = useState("Enable dark Mode")
    // const toggleStyle =()=>{
    //     if(myStyle.color === "white"){
    //         setMyStyle({
    //             color: 'black',
    //             backgroundColor: 'white'
    //         })
    //         setBtnText('Enable dark Mode')
    //     }
    //     else{
    //         setMyStyle({
    //             color:'white',
    //             backgroundColor:'black'
    //         })
    //         setBtnText('Enable light Mode')

    //     }
    // }
    // function someFun(){
    //     toggleStyle()
    //     prop.toggleMode()
    // }
    return (
        <>
            <div className="container" 

            style={{backgroundColor: prop.mode === 'dark'?'grey':'white', 
                        color : prop.mode === 'dark'?'white':'black'}}>
                <h1>About Us</h1>
                <div className="accordion" id="accordionExample">
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                            <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                                style={{backgroundColor: prop.mode === 'dark'?'grey':'white', 
                        color : prop.mode === 'dark'?'white':'black'}}>
                                Accordion Item #1
                            </button>
                        </h2>
                        <div
                            id="collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                            style={{backgroundColor: prop.mode === 'dark'?'grey':'white', 
                        color : prop.mode === 'dark'?'white':'black'}}>
                            <div className="accordion-body">
                                <strong>
                                    This is the first item's accordion body.
                                </strong>{" "}
                                It is shown by default, until the collapse
                                plugin adds the appropriate classes that we use
                                to style each element. These classes control the
                                overall appearance, as well as the showing and
                                hiding via CSS transitions. You can modify any
                                of this with custom CSS or overriding our
                                default variables. It's also worth noting that
                                just about any HTML can go within the{" "}
                                <code>.accordion-body</code>, though the
                                transition does limit overflow.
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                            <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseTwo"
                                aria-expanded="false"
                                aria-controls="collapseTwo"
                                style={{backgroundColor: prop.mode === 'dark'?'grey':'white', 
                        color : prop.mode === 'dark'?'white':'black'}}>
                                Accordion Item #2
                            </button>
                        </h2>
                        <div
                            id="collapseTwo"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                            style={{backgroundColor: prop.mode === 'dark'?'grey':'white', 
                        color : prop.mode === 'dark'?'white':'black'}}>
                            <div className="accordion-body">
                                <strong>
                                    This is the second item's accordion body.
                                </strong>{" "}
                                It is hidden by default, until the collapse
                                plugin adds the appropriate classes that we use
                                to style each element. These classes control the
                                overall appearance, as well as the showing and
                                hiding via CSS transitions. You can modify any
                                of this with custom CSS or overriding our
                                default variables. It's also worth noting that
                                just about any HTML can go within the{" "}
                                <code>.accordion-body</code>, though the
                                transition does limit overflow.
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingThree">
                            <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseThree"
                                aria-expanded="false"
                                aria-controls="collapseThree"
                                style={{backgroundColor: prop.mode === 'dark'?'grey':'white', 
                        color : prop.mode === 'dark'?'white':'black'}}>
                                Accordion Item #3
                            </button>
                        </h2>
                        <div
                            id="collapseThree"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingThree"
                            data-bs-parent="#accordionExample"
                            style={{backgroundColor: prop.mode === 'dark'?'grey':'white', 
                        color : prop.mode === 'dark'?'white':'black'}}>
                            <div className="accordion-body">
                                <strong>
                                    This is the third item's accordion body.
                                </strong>{" "}
                                It is hidden by default, until the collapse
                                plugin adds the appropriate classes that we use
                                to style each element. These classes control the
                                overall appearance, as well as the showing and
                                hiding via CSS transitions. You can modify any
                                of this with custom CSS or overriding our
                                default variables. It's also worth noting that
                                just about any HTML can go within the{" "}
                                <code>.accordion-body</code>, though the
                                transition does limit overflow.
                            </div>
                        </div>
                    </div>
                </div>
                {/* <button  className="btn btn-primary mt-3" onClick={someFun}>
                    {btnText}
                </button> */}
            </div>
        </>
    );
}
